export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11099.c3847d7d.jpg";